module.exports = __webpack_public_path__ + "media/svg/top-selected-557cb12a.svg";